/**
 * Converts relevantDocumentIds Record to array for display
 * Each entry is: documentId -> { relevance, contentType, reasoning, confidence, keyTerms }
 */

export interface AggregatedDocument {
  documentId: string;
  relevance: string;
  contentType: string;
  confidence?: number;
  reasoning?: string;
  keyTerms?: string[];
  score?: number;
  // These fields will be undefined - DocumentCard will fetch actual document data
  documentTitle?: string;
  knowledgebaseId?: string;
  knowledgebaseName?: string;
  knowledgebaseDomain?: string;
}

/**
 * Converts the relevantDocumentIds Record/map to an array
 * Note: Only includes metadata from relevantDocumentIds
 * Document details (title, KB name) should be fetched separately
 */
export function aggregateSearchResults(
  relevantDocumentIds: Record<string, any>
): AggregatedDocument[] {
  if (!relevantDocumentIds) return [];
  
  return Object.entries(relevantDocumentIds).map(([documentId, metadata]) => ({
    documentId,
    relevance: metadata.relevance || 'not_relevant',
    contentType: metadata.contentType || 'other',
    confidence: metadata.confidence,
    reasoning: metadata.reasoning,
    keyTerms: metadata.keyTerms || [],
    score: metadata.score,
  }));
}

